import Vue from 'vue';
import Router from 'vue-router';
import StarterNavbar from './layout/StarterNavbar.vue';
import StarterFooter from './layout/StarterFooter.vue';
import Starter from './pages/StarterPage.vue';

import Navbar from './layout/Navbar.vue';
import Footer from './layout/Footer.vue';

import Home from './layout/Home.vue'
import QuienesSomos from './pages/QuienesSomos.vue'
import Productos from './pages/Productos.vue'
import Contactenos from './pages/Contactenos.vue'
import Login from './pages/Login.vue'
import Pedidos from './pages/Pedidos.vue'
import Contacto from './pages/Contacto.vue'
import Redirector from './pages/components/Redirector.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      components: {
        default: Home,
        header: Navbar,
        footer: Footer
      },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'white' }
      }
    },
    {
      path: '/quienessomos',
      name: 'quienessomos',
      components: {
        default: QuienesSomos,
        header: Navbar,
        footer: Footer
      }
    },
    {
      path: '/productos',
      name: 'productos',
      components: {
        default: Productos,
        header: Navbar,
        footer: Footer
      }
    },
    {
      path: '/contactenos',
      name: 'contactenos',
      components: {
        default: Contactenos,
        header: Navbar,
        footer: Footer
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        default: Login,
        header: Navbar,
        footer: Footer
      }
    },
    {
      path: '/pedidos',
      name: 'pedidos',
      components: {
        default: Pedidos,
        header: Navbar,
        footer: Footer
      }
    },
    {
      path: '/contacto',
      name: 'contacto',
      components: {
        default: Contacto,
        header: Navbar,
        footer: Footer
      }
    },
    {
      path: '/index.html',
      component: Redirector
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
